<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/access">アクセス</router-link></li>
          <li><router-link to="/access/train">電車をご利用の方</router-link></li>
        </ul>
      </div> 
    </div>
    <div class="access">
      <div class="container">
        <h2 class="page--title">ACCESS<span>アクセス</span></h2>
        <AccessMenu :accessMenuChild="accessMenu" />
        <div class="tab-content">
          <div id="content--4" class="access__content content--4">
            <h2>電車の経路</h2>
            <div class="img_holder pc">
              <img
                src="@/assets/img/access/access_img_2.jpg"
                alt="access chart"
              />
            </div>
            <div class="img_holder sp">
              <img
                src="@/assets/img/access/sp/access_img_2.jpg"
                alt="access chart"
              />
            </div>
            <div class="link_holder">
              <a href="">
                <img
                  class="icocalender"
                  src="@/assets/img/access/svgfile/icon_cal_clock.svg"
                  alt=""
                />
                <span>地下鉄大江戸線 時刻表</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
            <h2>アクセスマップ</h2>
            <h3>路線図</h3>
            <div class="img_holder">
              <img
                src="@/assets/img/access/access_img_3.jpg"
                alt="access chart"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import CONSTANT from "../../../constant";
import { RouterLink } from "vue-router";

export default {
  name: "Train",
  components: {
    AccessMenu: () => import("@/components/common/AccessMenu.vue"),
  },
  data() {
    return {
      accessMenu: CONSTANT.dataAccessMenu,
    };
  },

  computed: {},
};
</script>